namespace GeniuzPOS.Product {
    export interface CsBrandRow {
        Id?: number;
        BrandCode?: string;
        BrandName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsBrandRow {
        export const idProperty = 'BrandCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsBrand';
        export const lookupKey = 'Product.CsBrand';

        export function getLookup(): Q.Lookup<CsBrandRow> {
            return Q.getLookup<CsBrandRow>('Product.CsBrand');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ยี่ห้อ:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ยี่ห้อ:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ยี่ห้อ:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ยี่ห้อ:Modify';

        export declare const enum Fields {
            Id = "Id",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
